import { OwlModule } from "ngx-owl-carousel";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { ClusterHostingComponent } from "./cluster-hosting.component";
import { RevolutionSliderClusterComponent } from './revolution-slider-cluster/revolution-slider-cluster.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { OurTestimonialComponent } from './our-testimonial/our-testimonial.component';
import { ResourcesComponent } from './resources/resources.component';
import { GetStartedComponent } from './get-started/get-started.component';
const routes: Routes = [
    { path: '', component: ClusterHostingComponent }
  ];
@NgModule({
    declarations: [
      ClusterHostingComponent,
      RevolutionSliderClusterComponent,
      AboutUsComponent,
      OurTestimonialComponent,
      ResourcesComponent,
      GetStartedComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        OwlModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        ClusterHostingComponent
    ]
  })
  export class ClusterHostingModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }